<template>
  <div class="info-banner" :class="computedClass">
    <div class="container-xl">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Info Banner',
  data() {
    return {};
  },
  components: {},
  props: {
    backgroundColor: {
      type: String,
      default: 'light',
    },
    textColor: {
      type: String,
      default: 'black',
    },
  },
  created: function() {},
  methods: {},
  computed: {
    computedClass() {
      let cls = [''];
      cls.push(`bg-${this.backgroundColor}`);
      cls.push(`text-${this.textColor}`);
      return cls;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
:slotted(strong) {
  @include body(md, $font-family-serif);
}
</style>
